<template>
    <span class="equaliser">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </span>
</template>

<script>
export default {
    name: 'equaliser'
}
</script>

<style lang="scss" scoped>
.equaliser {
    display: inline-block;
    height: 0.75em;
    width: 1em;
    margin: 0 0;
    padding: 0 0 0 0;
    position: relative;

    span {
        display: inline-block;
        width: calc((100% / 4) - 2px);
        height: 100%;
        margin-right: 2px;
        background-color: var(--ui-color);
        box-shadow: 1px 1px 5px var(--question-shadow-color);

        &:last-child {
            margin-right: 0;
        }

        &:nth-child(1) {
            animation: equaliser 2s 1s ease-out alternate infinite;
        }
        &:nth-child(2) {
            animation: equaliser 2s 0.5s ease-out alternate infinite;
        }
        &:nth-child(3) {
            animation: equaliser 2s 1.5s ease-out alternate infinite;
        }
        &:nth-child(4) {
            animation: equaliser 2s 0.25s ease-out alternate infinite;
        }

        @keyframes equaliser {
            0% {
                height: 10%;
            }
            10% {
                height: 30%;
            }
            20% {
                height: 50%;
            }
            30% {
                height: 20%;
            }
            40% {
                height: 70%;
            }
            50% {
                height: 100%;
            }
            60% {
                height: 30%;
            }
            70% {
                height: 100%;
            }
            80% {
                height: 50%;
            }
            90% {
                height: 30%;
            }
            100% {
                height: 10%;
            }
        }
    }
}
</style>